export default "__VITE_PUBLIC_ASSET__613b5212__"